import { Component } from '@angular/core';
import { SidebarRightService } from '../../../services/sidebar-right/sidebar-right.service';
import { LoginService } from '../../../../features/services';

@Component({
  selector: 'app-sidebar-right',
  templateUrl: './sidebar-right.component.html',
})
export class SidebarRightComponent {

  constructor(
    public sidebarRightS: SidebarRightService,
    public loginS: LoginService
  ) { }
}
